import { useState, useEffect, useCallback } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AdminSidebar }   from './AdminSidebar';
import { AdminLogin }     from './AdminLogin';
import { AdminBlogList }  from './AdminBlogList';
import { AdminBlogEditor } from './AdminBlogEditor';
import { adminGet, adminPost } from '../api/apiClient';
import './admin.scss';

function Toast({ message, isError, onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 3200);
    return () => clearTimeout(t);
  }, [onDone]);
  return (
    <div className={`admin-toast${isError ? ' admin-toast--error' : ''}`}>
      {message}
    </div>
  );
}

function ProtectedShell({ children }) {
  const [authed, setAuthed]   = useState(null); // null = checking
  const [collapsed, setCollapsed] = useState(false);
  const [toast, setToast]     = useState(null);
  const navigate  = useNavigate();
  const location  = useLocation();

  useEffect(() => {
    adminGet('/admin/me.php')
      .then(() => setAuthed(true))
      .catch((err) => {
        if (err.status === 401) setAuthed(false);
        else setAuthed(false);
      });
  }, []);

  const handleLogout = async () => {
    try { await adminPost('/admin/logout.php', {}); } catch { /* ignore */ }
    setAuthed(false);
    navigate('/admin/login');
  };

  const showToast = useCallback((message, isError = false) => {
    setToast({ message, isError });
  }, []);

  if (authed === null) {
    return (
      <div className="admin-root" style={{ alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: 'rgba(0,47,93,0.5)' }}>Ładowanie&hellip;</p>
      </div>
    );
  }

  if (!authed) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return (
    <div className="admin-root">
      <AdminSidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />

      <div className={`admin-content${collapsed ? ' admin-content--collapsed' : ''}`}>
        <header className="admin-topbar">
          <span className="admin-topbar__title">Panel administracyjny</span>
          <div className="admin-topbar__user">
            <span className="admin-topbar__username">Magdalena Pawlak</span>
            <button className="admin-topbar__logout-btn" onClick={handleLogout} type="button">
              Wyloguj
            </button>
          </div>
        </header>

        <main className="admin-page">
          {children({ showToast })}
        </main>
      </div>

      {toast && (
        <Toast message={toast.message} isError={toast.isError} onDone={() => setToast(null)} />
      )}
    </div>
  );
}

export function AdminLayout() {
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />

      <Route
        path="/admin/blogs"
        element={
          <ProtectedShell>
            {({ showToast }) => <AdminBlogList onToast={showToast} />}
          </ProtectedShell>
        }
      />
      <Route
        path="/admin/blogs/new"
        element={
          <ProtectedShell>
            {({ showToast }) => <AdminBlogEditor onToast={showToast} />}
          </ProtectedShell>
        }
      />
      <Route
        path="/admin/blogs/:id/edit"
        element={
          <ProtectedShell>
            {({ showToast }) => <AdminBlogEditor onToast={showToast} />}
          </ProtectedShell>
        }
      />

      <Route path="/admin" element={<Navigate to="/admin/blogs" replace />} />
      <Route path="/admin/*" element={<Navigate to="/admin/blogs" replace />} />
    </Routes>
  );
}
